module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headerTop', {
    attrs: {
      "value": "2"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "shenbaoA flex justify-between align-start",
    attrs: {
      "element-loading-text": "加载中"
    }
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "width": "100%",
      "padding": "20px 50px",
      "border-radius": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "box2_until"
  }, _vm._l((_vm.typelist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "borbot",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "box2_until_center"
    }, [_c('div', {
      staticClass: "box2_until_left"
    }, [_vm._v(_vm._s(item.name) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "box2_cent"
    }, _vm._l((item.union_type), function(citem, cindex) {
      return _c('div', {
        key: cindex,
        staticClass: "box2_until_right cpoint",
        class: citem.checked ? 'sty' : '',
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.tochoose(index, cindex, citem.id, citem.name, item.id, citem.pid)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(citem.name) + "\n\t\t\t\t\t\t\t\t")])
    }), 0)])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "shenbaoleft"
  }, [_c('ul', _vm._l((_vm.tablist), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "search cpoint",
      class: item.checked ? 'active1' : '',
      on: {
        "click": function($event) {
          return _vm.tochange(index, item.type, item.tindex)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t")])
  }), 0)]), _vm._v(" "), (_vm.rightlist.length) ? _c('div', {
    staticClass: "shenbaoright",
    staticStyle: {
      "width": "calc(100% - 140px)"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "550px"
    }
  }, _vm._l((_vm.rightlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box5"
    }, [_c('div', {
      staticClass: "box5_text1"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.title) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_c('span', [_vm._v(_vm._s(item.fbdj ? item.fbdj : '--'))])]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.fbqy ? item.fbqy : '--') + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.fbtime ? item.fbtime : '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(item.jztime ? _vm.$time(item.jztime) : '--'))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text2"
    }, [_vm._v(_vm._s(_vm.timetemp > item.jztime ? '已截止' : _vm.$days(_vm.$time(item.jztime), _vm.nowTime)))]), _vm._v(" "), _c('div', {
      staticClass: "box5_text3 text-cut"
    }, [_c('div', {
      staticClass: "box2_nei cpoint",
      on: {
        "click": function($event) {
          return _vm.todetail(item.href)
        }
      }
    }, [_vm._v("查看详情")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "10px 0"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.pagesize,
      "hide-on-single-page": true,
      "layout": "prev, pager, next",
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.rightlist.length) ? _c('div', {
    staticClass: "shenbaoright"
  }, [_vm._m(2)]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box1_header",
    staticStyle: {
      "margin-bottom": "20px",
      "border": "none"
    }
  }, [_c('div', {
    staticClass: "box1_header_shu"
  }), _vm._v(" "), _c('div', {
    staticClass: "box1_header_text"
  }, [_vm._v("政策资讯")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box5 box2_cc"
  }, [_c('div', {
    staticClass: "box5_text1 text-cut"
  }, [_vm._v("标题")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut"
  }, [_vm._v("发布等级")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut"
  }, [_vm._v("发布区域")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut"
  }, [_vm._v("发布日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut"
  }, [_vm._v("截止日期")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text2 text-cut"
  }, [_vm._v("剩余天数")]), _vm._v(" "), _c('div', {
    staticClass: "box5_text3 text-cut"
  }, [_vm._v("操作")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nodata flex justify-center align-center flex-direction"
  }, [_c('div', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("暂无数据")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e734488"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/policy/policy.vue
// module id = 1094
// module chunks = 1